import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Alert, Button, Form, Spinner } from "react-bootstrap";
import CopyToClipboard from "react-copy-to-clipboard";
import Swal from "sweetalert2"; // Add this import
import {
  useGenerateEosKeyQuery,
  useInsertPublicKeyMutation,
} from "../app/features/apiSlice";
import { toastError, toastSuccess } from "../helpers";
import { useParams } from "react-router";

const privateStar = "***************************************************";

const EosKey = ({refetch}) => {
  const sessionId = useRef(Date.now()).current;
  const { t } = useTranslation();
  const { lang } = useParams();
  const [showKey, setShowKey] = useState(privateStar);
  const [privateKey, setPrivateKey] = useState("123456789");
  const [publicKey, setPublicKey] = useState(null);
  const [isCheckboxChecked, setIsCheckboxChecked] = useState(false);
  const [copySuccess, setCopySuccess] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [isKeyDownloaded, setIsKeyDownloaded] = useState(false);

  const { data, isLoading, isSuccess, isError, error } = useGenerateEosKeyQuery(
    { sessionId }
  );

  const downloadKey = () => {
    let textToSave = t("yourPrivatekeyForEOSAccount") + privateKey;
    let hiddenElement = document.createElement("a");
    hiddenElement.href = "data:attachment/text," + encodeURI(textToSave);
    hiddenElement.target = "_blank";
    hiddenElement.download = "Excelior-myKey.txt";
    hiddenElement.click();
    setIsKeyDownloaded(true);
  };

  const [insertPublicKey, { isLoading: isSaving }] =
    useInsertPublicKeyMutation();
  
  const handleCheckbox = async (e) => {
    // Show SweetAlert confirmation dialog
    Swal.fire({
      title: t("confirmKeyStorageTitle") || "Are you sure?",
      text: t("confirmKeyStorageText") || "Have you safely stored your private key? Once you proceed, you won't be able to access it again.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#946D42",
      cancelButtonColor: "#282828",
      cancelButtonText: t("cancelButtonText") || "Cancel",
      confirmButtonText: t("yes") || "Yes, I've saved it",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setIsChecked(true);
        try {
          const data = {
            publicKey,
            language: lang,
          };
          const response = await insertPublicKey(data).unwrap();
          if (response?.error) {
            toastError(response, t("error.serverNotResponding"));
            setIsChecked(false);
          } else {
            toastSuccess(response?.message);
            toastSuccess(t("investmentProceed"));
            setIsCheckboxChecked(true);
            refetch();
          }
        } catch (err) {
          toastError(err, t("error.serverNotResponding"));
          setIsChecked(false); // Reset checkbox on error
        }
      }
    });
  };

  useEffect(() => {
    if (isSuccess && data) {
      setPrivateKey(data.privateKey);
      setPublicKey(data.publicKey);
    }
  }, [data, isSuccess]);

  if (isLoading) return <Spinner size="sm" className="ms-2" animation="grow" />;

  return (
    <>
      {isError && <p className="text-danger">{JSON.stringify(error)}</p>}
      {isSuccess && (
        <>
          <p className="text-light">{t("privateKeyWarning")}</p>

          <Alert
            variant="secondary"
            className="p-3"
            onMouseEnter={() => setShowKey(privateKey)}
            onMouseLeave={() => setShowKey(privateStar)}
          >
            <CopyToClipboard text={privateKey} onCopy={() => setCopySuccess(true)}>
              <i className="fa fa-copy fs-4 text"></i>
            </CopyToClipboard>
            <span className="p-3">{showKey}</span>
          </Alert>
          {copySuccess && (
            <span style={{ color: "green", marginLeft: "10px" }}>
              {t("copied")}
            </span>
          )}
          {/* <ClientPrivateKey privateKey={privateKey} /> */}
          {isCheckboxChecked ? (
            <div className="mt-3">
              <Alert variant="success" className="text-center">
                <p className="mb-0">{t("investmentProceed")}</p>
              </Alert>
            </div>
          ) : (
            <>
              <Button onClick={downloadKey} className="btn btn-primary">
                {t("downloadKeyAsTextFile")}
                {isSaving && (
                  <Spinner size="sm" className="ms-2" animation="grow" />
                )}
              </Button>
              {/* <Form.Group className="mb-3 mt-3" controlId="formBasicCheckbox">
                <Form.Check
                  type="checkbox"
                  label={t("confirmToStore")}
                  checked={isChecked}
                  onChange={handleCheckbox}
                  disabled={!isKeyDownloaded}
                />
                {!isKeyDownloaded && (
                  <Form.Text className="text-warning d-block mt-2">
                    {t("downloadKeyFirst") || "⚠️ Please download the key first before confirming"}
                  </Form.Text>
                )}
              </Form.Group> */}
            </>
          )}
        </>
      )}
    </>
  );
};

export default EosKey;